export { ValueProposition } from './ValueProposition';
